import { DataTableCard, PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import {PhoneList} from "./phonelist";

export const Phone = () => {

    return (
        <PageLayout>
            <PageLayoutRow>
                <PageLayoutHeader>
                    <PageLayoutTitle>Phone calls</PageLayoutTitle>
                </PageLayoutHeader>
            </PageLayoutRow>
            <PageLayoutRow>
                <DataTableCard size="large">
                    <PhoneList/>
                </DataTableCard>
            </PageLayoutRow>
        </PageLayout>
    );
};
